require("@awc/App/WidgetExtensions/Basic/BannerExtensions");
require("@awc/App/WidgetExtensions/Basic/BreadcrumbsExtensions");
require("@awc/App/WidgetExtensions/Basic/ImageExtensions");
require("@awc/App/WidgetExtensions/Basic/ItemListExtensions");
require("@awc/App/WidgetExtensions/Basic/LinkListExtensions");
require("@awc/App/WidgetExtensions/Basic/LogoExtensions");
require("@awc/App/WidgetExtensions/Basic/NavigationListExtensions");
require("@awc/App/WidgetExtensions/Basic/QuickOrderExtensions");
require("@awc/App/WidgetExtensions/Basic/RichContentExtensions");
require("@awc/App/WidgetExtensions/Basic/SlideshowExtensions");
require("@awc/App/WidgetExtensions/Basic/SocialLinksExtensions");
require("@awc/App/WidgetExtensions/Basic/SubscribeExtensions");
require("@awc/App/WidgetExtensions/Common/CartLinkExtensions");
require("@awc/App/WidgetExtensions/Common/CurrencyMenuExtensions");
require("@awc/App/WidgetExtensions/Common/HeaderShipToAddressExtensions");
require("@awc/App/WidgetExtensions/Common/HeaderSignInExtensions");
require("@awc/App/WidgetExtensions/Common/LanguageMenuExtensions");
require("@awc/App/WidgetExtensions/Common/ProductCarouselExtensions");
require("@awc/App/WidgetExtensions/Common/PurchasedProductsExtensions");
require("@awc/App/WidgetExtensions/Common/RecentOrdersExtensions");
require("@awc/App/WidgetExtensions/Common/RecentQuotesExtensions");
require("@awc/App/WidgetExtensions/Common/RecentWishListsExtensions");
require("@awc/App/WidgetExtensions/Footer/FooterContainerExtensions");
require("@awc/App/WidgetExtensions/Header/AddressDrawerContainerExtensions");
require("@awc/App/WidgetExtensions/Header/AddressDrawerFulfillmentMethodSelectorExtensions");
require("@awc/App/WidgetExtensions/Header/AutocompleteBrandsExtensions");
require("@awc/App/WidgetExtensions/Header/AutocompleteCategoriesExtensions");
require("@awc/App/WidgetExtensions/Header/AutocompleteContentExtensions");
require("@awc/App/WidgetExtensions/Header/AutocompleteProductsExtensions");
require("@awc/App/WidgetExtensions/Header/AutocompleteSuggestionsExtensions");
require("@awc/App/WidgetExtensions/Header/HeaderLinkListExtensions");
require("@awc/App/WidgetExtensions/Header/HeaderSearchInputExtensions");
require("@awc/App/WidgetExtensions/Header/MainNavigationExtensions");
require("@awc/App/WidgetExtensions/Header/SearchHistoryExtensions");
require("@awc/App/WidgetExtensions/Header/SearchInputExtensions");
require("@awc/App/WidgetExtensions/InvoiceDetails/InvoiceDetailsSummaryTableExtentions");
require("@awc/App/WidgetExtensions/InvoiceDetails/InvoiceDetailsTotalExtentions");
require("@awc/App/WidgetExtensions/InvoiceHistory/InvoiceHistoryBucketsExtenstions");
require("@awc/App/WidgetExtensions/OrderApprovalList/OrderApprovalListPaginationsExtensions");
require("@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchPoNumberExtensions");
require("@awc/App/WidgetExtensions/RfqMyQuotes/RfqMyQuotesPaginationsExtensions");
require("@awc/App/WidgetExtensions/SignIn/SignInChangePasswordFormExtensions");
require("@awc/App/WidgetExtensions/SignIn/SignInCreateNewAccountExtensions");
require("@awc/App/WidgetExtensions/SignIn/SignInExistingAccountExtensions");
require("@awc/App/WidgetExtensions/SignIn/SignInGuestExtensions");
require("@awc/App/WidgetExtensions/SignIn/SignInResetPasswordFormExtensions");
require("@awc/App/WidgetExtensions/xTabs/xTabsExtensions");

const importChunkObj: any = {
	"AccountSettings/AccountSettingsDefaultBillingShipping": () => {
        import(/* webpackChunkName: "accountsettingsChunk" */ "@awc/App/WidgetExtensions/AccountSettings/AccountSettingsDefaultBillingShippingExtensions");
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping"
        );
	},
	"AccountSettings/AccountSettingsHeader": () => {
        import(/* webpackChunkName: "accountsettingsChunk" */ "@awc/App/WidgetExtensions/AccountSettings/AccountSettingsHeaderExtensions");
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader"
        );
	},
	"AccountSettings/AccountSettingsManageSubscriptions": () => {
        import(/* webpackChunkName: "accountsettingsChunk" */ "@awc/App/WidgetExtensions/AccountSettings/AccountSettingsManageSubscriptionsExtensions");
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions"
        );
	},
	"AccountSettings/AccountSettingsUserInformation": () => {
        import(/* webpackChunkName: "accountsettingsChunk" */ "@awc/App/WidgetExtensions/AccountSettings/AccountSettingsUserInformationExtensions");
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation"
        );
	},
	"AccountSettings/DefaultBillingAddress": () => {
        import(/* webpackChunkName: "accountsettingsChunk" */ "@awc/App/WidgetExtensions/AccountSettings/DefaultBillingAddressExtensions");
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress"
        );
	},
	"AccountSettings/DefaultShippingAddress": () => {
        import(/* webpackChunkName: "accountsettingsChunk" */ "@awc/App/WidgetExtensions/AccountSettings/DefaultShippingAddressExtensions");
        return import(
            /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress"
        );
	},
	"AddressBookOverlay/AddressBook": () => {
        return import(
            /* webpackChunkName: "addressbookoverlayChunk" */ "@insite/content-library/Widgets/AddressBookOverlay/AddressBook"
        );
	},
	"Addresses/AddressBook": () => {
        import(/* webpackChunkName: "addressesChunk" */ "@awc/App/WidgetExtensions/Addresses/AddressBookExtensions");
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/AddressBook"
        );
	},
	"Addresses/AddressBookPagination": () => {
        import(/* webpackChunkName: "addressesChunk" */ "@awc/App/WidgetExtensions/Addresses/AddressBookPaginationExtensions");
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/AddressBookPagination"
        );
	},
	"Addresses/AddressBookSearchBox": () => {
        import(/* webpackChunkName: "addressesChunk" */ "@awc/App/WidgetExtensions/Addresses/AddressBookSearchBoxExtensions");
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/AddressBookSearchBox"
        );
	},
	"Addresses/CreateAddressButton": () => {
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/CreateAddressButton"
        );
	},
	"Addresses/CurrentBillingAddress": () => {
        import(/* webpackChunkName: "addressesChunk" */ "@awc/App/WidgetExtensions/Addresses/CurrentBillingAddressExtensions");
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/CurrentBillingAddress"
        );
	},
	"Addresses/CurrentShippingAddress": () => {
        import(/* webpackChunkName: "addressesChunk" */ "@awc/App/WidgetExtensions/Addresses/CurrentShippingAddressExtensions");
        return import(
            /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Widgets/Addresses/CurrentShippingAddress"
        );
	},
	"Brand/AlphabetNavigation": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/Brand/AlphabetNavigationExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/AlphabetNavigation"
        );
	},
	"Brand/BrandAlphabetNavigation": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/BrandAlphabetNavigation"
        );
	},
	"Brand/BrandGallery": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/Brand/BrandGalleryExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/BrandGallery"
        );
	},
	"Brand/BrandList": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/Brand/BrandListExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/BrandList"
        );
	},
	"Brand/FlexItem": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/FlexItem"
        );
	},
	"Brand/FlexWrapContainer": () => {
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/Brand/FlexWrapContainer"
        );
	},
	"BrandDetails/BrandDetailsCategories": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/BrandDetails/BrandDetailsCategoriesExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories"
        );
	},
	"BrandDetails/BrandDetailsContent": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/BrandDetails/BrandDetailsContentExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsContent"
        );
	},
	"BrandDetails/BrandDetailsImage": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/BrandDetails/BrandDetailsImageExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage"
        );
	},
	"BrandDetails/BrandDetailsLogo": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/BrandDetails/BrandDetailsLogoExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo"
        );
	},
	"BrandDetails/BrandDetailsProductLines": () => {
        import(/* webpackChunkName: "brandsChunk" */ "@awc/App/WidgetExtensions/BrandDetails/BrandDetailsProductLinesExtensions");
        return import(
            /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines"
        );
	},
	"Budget/AssignBudgets": () => {
        import(/* webpackChunkName: "budgetsChunk" */ "@awc/App/WidgetExtensions/Budget/AssignBudgetsExtensions");
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/AssignBudgets"
        );
	},
	"Budget/BudgetManagementHeader": () => {
        import(/* webpackChunkName: "budgetsChunk" */ "@awc/App/WidgetExtensions/Budget/BudgetManagementHeaderExtensions");
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/BudgetManagementHeader"
        );
	},
	"Budget/BudgetShipToDropdown": () => {
        import(/* webpackChunkName: "budgetsChunk" */ "@awc/App/WidgetExtensions/Budget/BudgetShipToDropdownExtensions");
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/BudgetShipToDropdown"
        );
	},
	"Budget/BudgetYearSelector": () => {
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/BudgetYearSelector"
        );
	},
	"Budget/ConfigureBudget": () => {
        import(/* webpackChunkName: "budgetsChunk" */ "@awc/App/WidgetExtensions/Budget/ConfigureBudgetExtensions");
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/ConfigureBudget"
        );
	},
	"Budget/CostCodes": () => {
        import(/* webpackChunkName: "budgetsChunk" */ "@awc/App/WidgetExtensions/Budget/CostCodesExtensions");
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/CostCodes"
        );
	},
	"Budget/EnforcementLevelDisplay": () => {
        import(/* webpackChunkName: "budgetsChunk" */ "@awc/App/WidgetExtensions/Budget/EnforcementLevelDisplayExtensions");
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/EnforcementLevelDisplay"
        );
	},
	"Budget/ReviewBudget": () => {
        import(/* webpackChunkName: "budgetsChunk" */ "@awc/App/WidgetExtensions/Budget/ReviewBudgetExtensions");
        return import(
            /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Widgets/Budget/ReviewBudget"
        );
	},
	"Cart/CartActions": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@awc/App/WidgetExtensions/Cart/CartActionsExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartActions"
        );
	},
	"Cart/CartFulfillmentMethodSelector": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@awc/App/WidgetExtensions/Cart/CartFulfillmentMethodSelectorExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector"
        );
	},
	"Cart/CartHeader": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@awc/App/WidgetExtensions/Cart/CartHeaderExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartHeader"
        );
	},
	"Cart/CartLineCardCondensed": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineCardCondensed"
        );
	},
	"Cart/CartLineCardExpanded": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@awc/App/WidgetExtensions/Cart/CartLineCardExpandedExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineCardExpanded"
        );
	},
	"Cart/CartLineNotes": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineNotes"
        );
	},
	"Cart/CartLineQuantity": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLineQuantity"
        );
	},
	"Cart/CartLines": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@awc/App/WidgetExtensions/Cart/CartLinesExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartLines"
        );
	},
	"Cart/CartPageContainer": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@awc/App/WidgetExtensions/Cart/CartPageContainerExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartPageContainer"
        );
	},
	"Cart/CartSaveOrderButton": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartSaveOrderButton"
        );
	},
	"Cart/CartTotal": () => {
        import(/* webpackChunkName: "cartsChunk" */ "@awc/App/WidgetExtensions/Cart/CartTotalExtensions");
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/Cart/CartTotal"
        );
	},
	"CartReminderUnsubscribe/CartReminderUnsubscribeMessage": () => {
        return import(
            /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Widgets/CartReminderUnsubscribe/CartReminderUnsubscribeMessage"
        );
	},
	"Category/CategoryDetailBanner": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryDetailBanner"
        );
	},
	"Category/CategoryDetailLinkList": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryDetailLinkList"
        );
	},
	"Category/CategoryDetailSubCategories": () => {
        import(/* webpackChunkName: "categoriesChunk" */ "@awc/App/WidgetExtensions/Category/CategoryDetailSubCategoriesExtensions");
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryDetailSubCategories"
        );
	},
	"Category/CategoryImage": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryImage"
        );
	},
	"Category/CategoryList": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryList"
        );
	},
	"Category/CategoryName": () => {
        return import(
            /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Widgets/Category/CategoryName"
        );
	},
	"ChangeCustomer/ChangeCustomerBillToSelector": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerBillToSelector"
        );
	},
	"ChangeCustomer/ChangeCustomerFulfillmentMethodSelector": () => {
        import(/* webpackChunkName: "changesChunk" */ "@awc/App/WidgetExtensions/ChangeCustomer/ChangeCustomerFulfillmentMethodSelectorExtensions");
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector"
        );
	},
	"ChangeCustomer/ChangeCustomerSelectCustomer": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomer"
        );
	},
	"ChangeCustomer/ChangeCustomerSelectCustomerContainer": () => {
        import(/* webpackChunkName: "changesChunk" */ "@awc/App/WidgetExtensions/ChangeCustomer/ChangeCustomerSelectCustomerContainerExtensions");
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer"
        );
	},
	"ChangeCustomer/ChangeCustomerShipToSelector": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerShipToSelector"
        );
	},
	"ChangePassword/ChangePassword": () => {
        import(/* webpackChunkName: "changesChunk" */ "@awc/App/WidgetExtensions/ChangePassword/ChangePasswordExtensions");
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangePassword/ChangePassword"
        );
	},
	"ChangePassword/ChangePasswordActions": () => {
        import(/* webpackChunkName: "changesChunk" */ "@awc/App/WidgetExtensions/ChangePassword/ChangePasswordActionsExtensions");
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions"
        );
	},
	"ChangePassword/ChangePasswordHeader": () => {
        return import(
            /* webpackChunkName: "changesChunk" */ "@insite/content-library/Widgets/ChangePassword/ChangePasswordHeader"
        );
	},
	"CheckoutReviewAndSubmit/AdyenDropIn": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/AdyenDropIn"
        );
	},
	"CheckoutReviewAndSubmit/BillingAddressInfoDisplay": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay"
        );
	},
	"CheckoutReviewAndSubmit/BillingAndShippingInfo": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierServiceExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotalExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetailsExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPlaceOrderButton": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPlaceOrderButton"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductListExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitProductList"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCodeExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo"
        );
	},
	"CheckoutReviewAndSubmit/CheckoutReviewAndSubmitSubmitForApprovalButton": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitSubmitForApprovalButton"
        );
	},
	"CheckoutReviewAndSubmit/CreditCardBillingAddressEntry": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry"
        );
	},
	"CheckoutReviewAndSubmit/CreditCardDetailsEntry": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutReviewAndSubmit/CreditCardDetailsEntryExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry"
        );
	},
	"CheckoutReviewAndSubmit/ECheckDetailsEntry": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ECheckDetailsEntry"
        );
	},
	"CheckoutReviewAndSubmit/GooglePayButtonWrapper": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/GooglePayButtonWrapper"
        );
	},
	"CheckoutReviewAndSubmit/PayPalButton": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PayPalButton"
        );
	},
	"CheckoutReviewAndSubmit/PaymentProfileBillingAddress": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress"
        );
	},
	"CheckoutReviewAndSubmit/PickUpLocation": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocation"
        );
	},
	"CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay"
        );
	},
	"CheckoutReviewAndSubmit/SavedPaymentProfileEntry": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutReviewAndSubmit/SavedPaymentProfileEntryExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry"
        );
	},
	"CheckoutReviewAndSubmit/ShippingAddressInfoDisplay": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay"
        );
	},
	"CheckoutShipping/BillingAddress": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/BillingAddress"
        );
	},
	"CheckoutShipping/BillingAddressForm": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutShipping/BillingAddressFormExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/BillingAddressForm"
        );
	},
	"CheckoutShipping/CheckoutShippingAdditionalEmails": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAdditionalEmails"
        );
	},
	"CheckoutShipping/CheckoutShippingAddresses": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutShipping/CheckoutShippingAddressesExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses"
        );
	},
	"CheckoutShipping/CheckoutShippingCartTotal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingCartTotal"
        );
	},
	"CheckoutShipping/CheckoutShippingFulfillmentMethodSelector": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingFulfillmentMethodSelector"
        );
	},
	"CheckoutShipping/CheckoutShippingHeader": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutShipping/CheckoutShippingHeaderExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader"
        );
	},
	"CheckoutShipping/CheckoutShippingOrderNotesEntry": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutShipping/CheckoutShippingOrderNotesEntryExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingOrderNotesEntry"
        );
	},
	"CheckoutShipping/CheckoutShippingPageContainer": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutShipping/CheckoutShippingPageContainerExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingPageContainer"
        );
	},
	"CheckoutShipping/CreateNewAddressModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/CreateNewAddressModal"
        );
	},
	"CheckoutShipping/EditExistingAddressModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/EditExistingAddressModal"
        );
	},
	"CheckoutShipping/PickUpAddress": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/PickUpAddress"
        );
	},
	"CheckoutShipping/ShippingAddress": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutShipping/ShippingAddressExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress"
        );
	},
	"CheckoutShipping/ShippingAddressForm": () => {
        import(/* webpackChunkName: "checkoutsChunk" */ "@awc/App/WidgetExtensions/CheckoutShipping/ShippingAddressFormExtensions");
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/CheckoutShipping/ShippingAddressForm"
        );
	},
	"CompactHeader/Cart": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Cart"
        );
	},
	"CompactHeader/Flyout": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Flyout"
        );
	},
	"CompactHeader/Logo": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Logo"
        );
	},
	"CompactHeader/MainNavigation": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/MainNavigation"
        );
	},
	"CompactHeader/Search": () => {
        return import(
            /* webpackChunkName: "compactheaderChunk" */ "@insite/content-library/Widgets/CompactHeader/Search"
        );
	},
	"ContactUs/AvailableTopics": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/AvailableTopics"
        );
	},
	"ContactUs/ContactForm": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/ContactForm"
        );
	},
	"ContactUs/EmailAddress": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/EmailAddress"
        );
	},
	"ContactUs/FirstName": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/FirstName"
        );
	},
	"ContactUs/LastName": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/LastName"
        );
	},
	"ContactUs/Message": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/Message"
        );
	},
	"ContactUs/PhoneNumber": () => {
        return import(
            /* webpackChunkName: "contactusChunk" */ "@insite/content-library/Widgets/ContactUs/PhoneNumber"
        );
	},
	"CreateAccount/CreateAccount": () => {
        import(/* webpackChunkName: "createaccountChunk" */ "@awc/App/WidgetExtensions/CreateAccount/CreateAccountExtensions");
        return import(
            /* webpackChunkName: "createaccountChunk" */ "@insite/content-library/Widgets/CreateAccount/CreateAccount"
        );
	},
	"DealerDetails/DealerInformation": () => {
        return import(
            /* webpackChunkName: "dealerdetailsChunk" */ "@insite/content-library/Widgets/DealerDetails/DealerInformation"
        );
	},
	"DealerDetails/DealerLocationMap": () => {
        return import(
            /* webpackChunkName: "dealerdetailsChunk" */ "@insite/content-library/Widgets/DealerDetails/DealerLocationMap"
        );
	},
	"InvoiceDetails/InvoiceDetailHeader": () => {
        import(/* webpackChunkName: "invoicesChunk" */ "@awc/App/WidgetExtensions/InvoiceDetails/InvoiceDetailHeaderExtensions");
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader"
        );
	},
	"InvoiceDetails/InvoiceDetailsBillingAddress": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsBillingAddress"
        );
	},
	"InvoiceDetails/InvoiceDetailsInformation": () => {
        import(/* webpackChunkName: "invoicesChunk" */ "@awc/App/WidgetExtensions/InvoiceDetails/InvoiceDetailsInformationExtensions");
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsInformation"
        );
	},
	"InvoiceDetails/InvoiceDetailsLineCard": () => {
        import(/* webpackChunkName: "invoicesChunk" */ "@awc/App/WidgetExtensions/InvoiceDetails/InvoiceDetailsLineCardExtensions");
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard"
        );
	},
	"InvoiceDetails/InvoiceDetailsShippingAddress": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsShippingAddress"
        );
	},
	"InvoiceDetails/InvoiceDetailsSummaryTable": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsSummaryTable"
        );
	},
	"InvoiceDetails/InvoiceDetailsTotal": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal"
        );
	},
	"InvoiceHistory/InvoiceHistoryBuckets": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryBuckets"
        );
	},
	"InvoiceHistory/InvoiceHistoryFilter": () => {
        import(/* webpackChunkName: "invoicesChunk" */ "@awc/App/WidgetExtensions/InvoiceHistory/InvoiceHistoryFilterExtensions");
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter"
        );
	},
	"InvoiceHistory/InvoiceHistoryHeader": () => {
        import(/* webpackChunkName: "invoicesChunk" */ "@awc/App/WidgetExtensions/InvoiceHistory/InvoiceHistoryHeaderExtensions");
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader"
        );
	},
	"InvoiceHistory/InvoiceHistoryPagination": () => {
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryPagination"
        );
	},
	"InvoiceHistory/InvoiceHistoryTable": () => {
        import(/* webpackChunkName: "invoicesChunk" */ "@awc/App/WidgetExtensions/InvoiceHistory/InvoiceHistoryTableExtensions");
        return import(
            /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryTable"
        );
	},
	"LlmsTxt/LlmsTxtContent": () => {
        return import(
            /* webpackChunkName: "llmstxtChunk" */ "@insite/content-library/Widgets/LlmsTxt/LlmsTxtContent"
        );
	},
	"LocationFinder/LocationFinder": () => {
        return import(
            /* webpackChunkName: "locationfinderChunk" */ "@insite/content-library/Widgets/LocationFinder/LocationFinder"
        );
	},
	"LocationFinder/LocationFinderDealerDisplay": () => {
        return import(
            /* webpackChunkName: "locationfinderChunk" */ "@insite/content-library/Widgets/LocationFinder/LocationFinderDealerDisplay"
        );
	},
	"ManifestJson/ManifestJsonContent": () => {
        return import(
            /* webpackChunkName: "manifestjsonChunk" */ "@insite/content-library/Widgets/ManifestJson/ManifestJsonContent"
        );
	},
	"MyAccount/AccountMessages": () => {
        import(/* webpackChunkName: "myaccountChunk" */ "@awc/App/WidgetExtensions/MyAccount/AccountMessagesExtensions");
        return import(
            /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Widgets/MyAccount/AccountMessages"
        );
	},
	"MyAccount/MyAccountHomepageSelector": () => {
        import(/* webpackChunkName: "myaccountChunk" */ "@awc/App/WidgetExtensions/MyAccount/MyAccountHomepageSelectorExtensions");
        return import(
            /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Widgets/MyAccount/MyAccountHomepageSelector"
        );
	},
	"MyAccount/MyAccountView": () => {
        import(/* webpackChunkName: "myaccountChunk" */ "@awc/App/WidgetExtensions/MyAccount/MyAccountViewExtensions");
        return import(
            /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Widgets/MyAccount/MyAccountView"
        );
	},
	"MyLists/MyListsCreateListButton": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsCreateListButtonExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsCreateListButton"
        );
	},
	"MyLists/MyListsEditListForm": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsEditListFormExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsEditListForm"
        );
	},
	"MyLists/MyListsFilter": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsFilterExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsFilter"
        );
	},
	"MyLists/MyListsHeader": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsHeaderExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsHeader"
        );
	},
	"MyLists/MyListsList": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsListExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsList"
        );
	},
	"MyLists/MyListsPagination": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsPaginationExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsPagination"
        );
	},
	"MyLists/MyListsSearchBox": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsSearchBoxExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchBox"
        );
	},
	"MyLists/MyListsSearchFieldBrand": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchFieldBrand"
        );
	},
	"MyLists/MyListsSearchFieldProductNumber": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchFieldProductNumber"
        );
	},
	"MyLists/MyListsSearchFieldSharedBy": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSearchFieldSharedBy"
        );
	},
	"MyLists/MyListsSortControl": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsSortControlExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsSortControl"
        );
	},
	"MyLists/MyListsView": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsViewExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/MyListsView"
        );
	},
	"MyLists/SearchFieldWrapper": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyLists/SearchFieldWrapper"
        );
	},
	"MyListsDetails/AddTagsModal": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/AddTagsModalExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/AddTagsModal"
        );
	},
	"MyListsDetails/MyListDetailsDiscontinuedProductListLine": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListDetailsDiscontinuedProductListLineExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListDetailsDiscontinuedProductListLine"
        );
	},
	"MyListsDetails/MyListDetailsPagination": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListDetailsPaginationExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination"
        );
	},
	"MyListsDetails/MyListsDetailsActions": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListsDetailsActionsExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions"
        );
	},
	"MyListsDetails/MyListsDetailsCopyListForm": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListsDetailsCopyListFormExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm"
        );
	},
	"MyListsDetails/MyListsDetailsHeader": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListsDetailsHeaderExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader"
        );
	},
	"MyListsDetails/MyListsDetailsOptions": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListsDetailsOptionsExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions"
        );
	},
	"MyListsDetails/MyListsDetailsProductList": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListsDetailsProductListExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList"
        );
	},
	"MyListsDetails/MyListsDetailsProductListLine": () => {
        import(/* webpackChunkName: "mylistsChunk" */ "@awc/App/WidgetExtensions/MyListsDetails/MyListsDetailsProductListLineExtensions");
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine"
        );
	},
	"MyListsDetails/ViewReplacementProductModal": () => {
        return import(
            /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Widgets/MyListsDetails/ViewReplacementProductModal"
        );
	},
	"NewsList/NewsListView": () => {
        return import(
            /* webpackChunkName: "newsChunk" */ "@insite/content-library/Widgets/NewsList/NewsListView"
        );
	},
	"NewsPage/NewsPageView": () => {
        return import(
            /* webpackChunkName: "newsChunk" */ "@insite/content-library/Widgets/NewsPage/NewsPageView"
        );
	},
	"OnePageCheckout/BillToSelectorModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/BillToSelectorModal"
        );
	},
	"OnePageCheckout/BillingAddressForm": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/BillingAddressForm"
        );
	},
	"OnePageCheckout/OnePageCheckoutDeliveryMethod": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod"
        );
	},
	"OnePageCheckout/OnePageCheckoutOrderSummary": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutOrderSummary"
        );
	},
	"OnePageCheckout/OnePageCheckoutPageContainer": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutPageContainer"
        );
	},
	"OnePageCheckout/OnePageCheckoutPaymentDetails": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutPaymentDetails"
        );
	},
	"OnePageCheckout/OnePageCheckoutReviewAndPlaceOrder": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutReviewAndPlaceOrder"
        );
	},
	"OnePageCheckout/OnePageCheckoutShippingSection": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutShippingSection"
        );
	},
	"OnePageCheckout/ShipToSelectorModal": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/ShipToSelectorModal"
        );
	},
	"OnePageCheckout/ShippingAddressForm": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckout/ShippingAddressForm"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummary": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummary"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod"
        );
	},
	"OnePageCheckoutConfirmation/OnePageCheckoutConfirmationProductList": () => {
        return import(
            /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationProductList"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsActionButtons": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsActionButtonsExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsBillingInformation": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsBillingInformation"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsHeader": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsHeaderExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsOrderInformation": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsOrderInformationExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsProductList": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsProductListExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsProductList"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsShippingInformation": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsShippingInformation"
        );
	},
	"OrderApprovalDetails/OrderApprovalDetailsTotal": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalDetails/OrderApprovalDetailsTotalExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsTotal"
        );
	},
	"OrderApprovalList/OrderApprovalListFilter": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalList/OrderApprovalListFilterExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter"
        );
	},
	"OrderApprovalList/OrderApprovalListHeader": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalList/OrderApprovalListHeaderExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListHeader"
        );
	},
	"OrderApprovalList/OrderApprovalListPagination": () => {
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListPagination"
        );
	},
	"OrderApprovalList/OrderApprovalListTable": () => {
        import(/* webpackChunkName: "orderapprovalChunk" */ "@awc/App/WidgetExtensions/OrderApprovalList/OrderApprovalListTableExtensions");
        return import(
            /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListTable"
        );
	},
	"OrderConfirmation/OrderConfirmationAccountSignUpMessage": () => {
        import(/* webpackChunkName: "orderconfirmationChunk" */ "@awc/App/WidgetExtensions/OrderConfirmation/OrderConfirmationAccountSignUpMessageExtensions");
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage"
        );
	},
	"OrderConfirmation/OrderConfirmationBillingInformation": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation"
        );
	},
	"OrderConfirmation/OrderConfirmationHeader": () => {
        import(/* webpackChunkName: "orderconfirmationChunk" */ "@awc/App/WidgetExtensions/OrderConfirmation/OrderConfirmationHeaderExtensions");
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader"
        );
	},
	"OrderConfirmation/OrderConfirmationOrderInformation": () => {
        import(/* webpackChunkName: "orderconfirmationChunk" */ "@awc/App/WidgetExtensions/OrderConfirmation/OrderConfirmationOrderInformationExtensions");
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationOrderInformation"
        );
	},
	"OrderConfirmation/OrderConfirmationPageContainer": () => {
        import(/* webpackChunkName: "orderconfirmationChunk" */ "@awc/App/WidgetExtensions/OrderConfirmation/OrderConfirmationPageContainerExtensions");
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer"
        );
	},
	"OrderConfirmation/OrderConfirmationProductList": () => {
        import(/* webpackChunkName: "orderconfirmationChunk" */ "@awc/App/WidgetExtensions/OrderConfirmation/OrderConfirmationProductListExtensions");
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationProductList"
        );
	},
	"OrderConfirmation/OrderConfirmationShippingInformation": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation"
        );
	},
	"OrderConfirmation/OrderConfirmationTotal": () => {
        return import(
            /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationTotal"
        );
	},
	"OrderDetails/OrderCancel": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderCancel"
        );
	},
	"OrderDetails/OrderCancelNotification": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderCancelNotification"
        );
	},
	"OrderDetails/OrderDate": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDateExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDate"
        );
	},
	"OrderDetails/OrderDetailsBillingAddress": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsBillingAddressExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress"
        );
	},
	"OrderDetails/OrderDetailsButtonSet": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsButtonSetExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet"
        );
	},
	"OrderDetails/OrderDetailsCreditCardBillingAddress": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsCreditCardBillingAddress"
        );
	},
	"OrderDetails/OrderDetailsNotes": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsNotesExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes"
        );
	},
	"OrderDetails/OrderDetailsPaymentTerms": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsPaymentTermsExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsPaymentTerms"
        );
	},
	"OrderDetails/OrderDetailsRequestedDate": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsRequestedDateExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate"
        );
	},
	"OrderDetails/OrderDetailsShipmentPackages": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsShipmentPackages"
        );
	},
	"OrderDetails/OrderDetailsShippingAddress": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsShippingAddressExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress"
        );
	},
	"OrderDetails/OrderDetailsShippingMethod": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsShippingMethodExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod"
        );
	},
	"OrderDetails/OrderDetailsStatus": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsStatusExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus"
        );
	},
	"OrderDetails/OrderDetailsSummaryTable": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsSummaryTableExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable"
        );
	},
	"OrderDetails/OrderDetailsTitle": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsTitleExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsTitle"
        );
	},
	"OrderDetails/OrderDetailsTotal": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsTotal"
        );
	},
	"OrderDetails/OrderDetailsVatNumber": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsVatNumberExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsVatNumber"
        );
	},
	"OrderDetails/OrderDetailsVmiLocation": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsVmiLocationExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderDetailsVmiLocation"
        );
	},
	"OrderDetails/OrderPo": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderPoExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderPo"
        );
	},
	"OrderDetails/OrderSalesperson": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderSalespersonExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/OrderDetails/OrderSalesperson"
        );
	},
	"OrderHistory/OrderHistoryHeader": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistoryHeaderExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader"
        );
	},
	"OrderHistory/OrderHistoryPagination": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryPagination"
        );
	},
	"OrderHistory/OrderHistoryResultCount": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryResultCount"
        );
	},
	"OrderHistory/OrderHistorySearchClearButton": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchClearButtonExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton"
        );
	},
	"OrderHistory/OrderHistorySearchField": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchField"
        );
	},
	"OrderHistory/OrderHistorySearchFieldDateRange": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldDateRangeExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange"
        );
	},
	"OrderHistory/OrderHistorySearchFieldOrderNumber": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldOrderNumberExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderNumber"
        );
	},
	"OrderHistory/OrderHistorySearchFieldOrderTotal": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldOrderTotalExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderTotal"
        );
	},
	"OrderHistory/OrderHistorySearchFieldOrderTotalOperator": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldOrderTotalOperatorExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderTotalOperator"
        );
	},
	"OrderHistory/OrderHistorySearchFieldPoNumber": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldPoNumber"
        );
	},
	"OrderHistory/OrderHistorySearchFieldProductErpNumber": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldProductErpNumberExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber"
        );
	},
	"OrderHistory/OrderHistorySearchFieldProductErpNumber2": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldProductErpNumber2Extensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber2"
        );
	},
	"OrderHistory/OrderHistorySearchFieldShipTos": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldShipTosExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShipTos"
        );
	},
	"OrderHistory/OrderHistorySearchFieldShowMyOrders": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShowMyOrders"
        );
	},
	"OrderHistory/OrderHistorySearchFieldStatus": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchFieldStatusExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldStatus"
        );
	},
	"OrderHistory/OrderHistorySearchFieldVmiLocation": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldVmiLocation"
        );
	},
	"OrderHistory/OrderHistorySearchForm": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm"
        );
	},
	"OrderHistory/OrderHistorySearchTags": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistorySearchTagsExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags"
        );
	},
	"OrderHistory/OrderHistoryTable": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistoryTableExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable"
        );
	},
	"OrderHistory/SearchFieldWrapper": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/SearchFieldWrapperExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper"
        );
	},
	"OrderHistory/SearchTextField": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/OrderHistory/SearchTextField"
        );
	},
	"OrderStatus/OrderStatusAddressDetails": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusAddressDetails"
        );
	},
	"OrderStatus/OrderStatusForm": () => {
        import(/* webpackChunkName: "orderstatusChunk" */ "@awc/App/WidgetExtensions/OrderStatus/OrderStatusFormExtensions");
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusForm"
        );
	},
	"OrderStatus/OrderStatusHeader": () => {
        import(/* webpackChunkName: "orderstatusChunk" */ "@awc/App/WidgetExtensions/OrderStatus/OrderStatusHeaderExtensions");
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusHeader"
        );
	},
	"OrderStatus/OrderStatusInformation": () => {
        import(/* webpackChunkName: "orderstatusChunk" */ "@awc/App/WidgetExtensions/OrderStatus/OrderStatusInformationExtensions");
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusInformation"
        );
	},
	"OrderStatus/OrderStatusProductList": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusProductList"
        );
	},
	"OrderStatus/OrderStatusShipmentPackages": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusShipmentPackages"
        );
	},
	"OrderStatus/OrderStatusTotal": () => {
        return import(
            /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Widgets/OrderStatus/OrderStatusTotal"
        );
	},
	"OrderUpload/OrderUploadFileUpload": () => {
        return import(
            /* webpackChunkName: "orderuploadChunk" */ "@insite/content-library/Widgets/OrderUpload/OrderUploadFileUpload"
        );
	},
	"OrderUpload/OrderUploadPageContainer": () => {
        import(/* webpackChunkName: "orderuploadChunk" */ "@awc/App/WidgetExtensions/OrderUpload/OrderUploadPageContainerExtensions");
        return import(
            /* webpackChunkName: "orderuploadChunk" */ "@insite/content-library/Widgets/OrderUpload/OrderUploadPageContainer"
        );
	},
	"Product/ProductImage": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/Product/ProductImage"
        );
	},
	"Product/ProductName": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/Product/ProductName"
        );
	},
	"ProductCompare/ProductCompareCarousel": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductCompare/ProductCompareCarouselExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel"
        );
	},
	"ProductDetails/ProductDetailsAddToCartButton": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsAddToCartButtonExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton"
        );
	},
	"ProductDetails/ProductDetailsAddToListLink": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsAddToListLinkExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink"
        );
	},
	"ProductDetails/ProductDetailsAttributes": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsAttributesExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAttributes"
        );
	},
	"ProductDetails/ProductDetailsAvailability": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability"
        );
	},
	"ProductDetails/ProductDetailsBundleSectionOptions": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsBundleSectionOptions"
        );
	},
	"ProductDetails/ProductDetailsCustomerPartNumber": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsCustomerPartNumberExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsCustomerPartNumber"
        );
	},
	"ProductDetails/ProductDetailsDeliveryScheduleButton": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsDeliveryScheduleButton"
        );
	},
	"ProductDetails/ProductDetailsDescription": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsDescriptionExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription"
        );
	},
	"ProductDetails/ProductDetailsDocuments": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsDocumentsExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsDocuments"
        );
	},
	"ProductDetails/ProductDetailsImageBadge": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsImageBadgeExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageBadge"
        );
	},
	"ProductDetails/ProductDetailsImageCarousel": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel"
        );
	},
	"ProductDetails/ProductDetailsKitSectionOptions": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsKitSectionOptions"
        );
	},
	"ProductDetails/ProductDetailsManufacturingPartNumber": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsManufacturingPartNumberExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber"
        );
	},
	"ProductDetails/ProductDetailsPageTitle": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsPageTitleExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle"
        );
	},
	"ProductDetails/ProductDetailsPartNumber": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsPartNumberExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber"
        );
	},
	"ProductDetails/ProductDetailsPrice": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsPriceExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice"
        );
	},
	"ProductDetails/ProductDetailsPrimaryImage": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsPrimaryImageExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage"
        );
	},
	"ProductDetails/ProductDetailsQuantityBreakPricing": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityBreakPricing"
        );
	},
	"ProductDetails/ProductDetailsQuantityOrdered": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered"
        );
	},
	"ProductDetails/ProductDetailsShareLink": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsShareLinkExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink"
        );
	},
	"ProductDetails/ProductDetailsSpecifications": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsSpecificationsExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsSpecifications"
        );
	},
	"ProductDetails/ProductDetailsTextBadge": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsTextBadge"
        );
	},
	"ProductDetails/ProductDetailsUnitOfMeasureSelect": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect"
        );
	},
	"ProductDetails/ProductDetailsVariantButton": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantButton"
        );
	},
	"ProductDetails/ProductDetailsVariantDropdown": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsVariantDropdownExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantDropdown"
        );
	},
	"ProductDetails/ProductDetailsVariantOptions": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantOptions"
        );
	},
	"ProductDetails/ProductDetailsVariantSwatchDropdown": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchDropdown"
        );
	},
	"ProductDetails/ProductDetailsVariantSwatchGrid": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchGrid"
        );
	},
	"ProductDetails/ProductDetailsVariantSwatchList": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchList"
        );
	},
	"ProductDetails/ProductDetailsView": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsViewExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductDetails/ProductDetailsView"
        );
	},
	"ProductList/ProductCardSelections": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductCardSelections"
        );
	},
	"ProductList/ProductListActions": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListActionsExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListActions"
        );
	},
	"ProductList/ProductListAttributeFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListAttributeFilters"
        );
	},
	"ProductList/ProductListBrandFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListBrandFilters"
        );
	},
	"ProductList/ProductListCardList": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListCardListExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListCardList"
        );
	},
	"ProductList/ProductListCategoryFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters"
        );
	},
	"ProductList/ProductListColumns": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListColumnsExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListColumns"
        );
	},
	"ProductList/ProductListColumnsDrawer": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListColumnsDrawer"
        );
	},
	"ProductList/ProductListControlsContainer": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListControlsContainerExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListControlsContainer"
        );
	},
	"ProductList/ProductListFilterAccordionSection": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListFilterAccordionSectionExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection"
        );
	},
	"ProductList/ProductListFilterList": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListFilterListExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListFilterList"
        );
	},
	"ProductList/ProductListFiltersAccordion": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListFiltersAccordionExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion"
        );
	},
	"ProductList/ProductListPagination": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListPaginationExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListPagination"
        );
	},
	"ProductList/ProductListPreviouslyPurchasedFilter": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListPreviouslyPurchasedFilter"
        );
	},
	"ProductList/ProductListPriceFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListPriceFilters"
        );
	},
	"ProductList/ProductListProductCard": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListProductCardExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductCard"
        );
	},
	"ProductList/ProductListProductContext": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductContext"
        );
	},
	"ProductList/ProductListProductCount": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListProductCountExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductCount"
        );
	},
	"ProductList/ProductListProductGridCard": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListProductGridCardExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductGridCard"
        );
	},
	"ProductList/ProductListProductImage": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListProductImageExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductImage"
        );
	},
	"ProductList/ProductListProductInformation": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListProductInformationExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductInformation"
        );
	},
	"ProductList/ProductListProductLineFilters": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductLineFilters"
        );
	},
	"ProductList/ProductListProductTableRow": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListProductTableRow"
        );
	},
	"ProductList/ProductListSearchWithin": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListSearchWithinExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListSearchWithin"
        );
	},
	"ProductList/ProductListSortSelect": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListSortSelectExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListSortSelect"
        );
	},
	"ProductList/ProductListStockedItemsFilter": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListStockedItemsFilter"
        );
	},
	"ProductList/ProductListSuggestion": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListSuggestion"
        );
	},
	"ProductList/ProductListTable": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListTableExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListTable"
        );
	},
	"ProductList/ProductListTableViewFilter": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListTableViewFilterExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListTableViewFilter"
        );
	},
	"ProductList/ProductListVariantSwatch": () => {
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListVariantSwatch"
        );
	},
	"ProductList/ProductListViewSelect": () => {
        import(/* webpackChunkName: "productsChunk" */ "@awc/App/WidgetExtensions/ProductList/ProductListViewSelectExtensions");
        return import(
            /* webpackChunkName: "productsChunk" */ "@insite/content-library/Widgets/ProductList/ProductListViewSelect"
        );
	},
	"QuickOrder/QuickOrderActions": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/QuickOrder/QuickOrderActionsExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderActions"
        );
	},
	"QuickOrder/QuickOrderPageContainer": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/QuickOrder/QuickOrderPageContainerExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer"
        );
	},
	"QuickOrder/QuickOrderProductList": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/QuickOrder/QuickOrderProductListExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList"
        );
	},
	"QuickOrder/QuickOrderSearch": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/QuickOrder/QuickOrderSearchExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch"
        );
	},
	"RequestRma/RequestRmaButtons": () => {
        import(/* webpackChunkName: "requestrmaChunk" */ "@awc/App/WidgetExtensions/RequestRma/RequestRmaButtonsExtensions");
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaButtons"
        );
	},
	"RequestRma/RequestRmaHeader": () => {
        import(/* webpackChunkName: "requestrmaChunk" */ "@awc/App/WidgetExtensions/RequestRma/RequestRmaHeaderExtensions");
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaHeader"
        );
	},
	"RequestRma/RequestRmaInformation": () => {
        import(/* webpackChunkName: "requestrmaChunk" */ "@awc/App/WidgetExtensions/RequestRma/RequestRmaInformationExtensions");
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaInformation"
        );
	},
	"RequestRma/RequestRmaNotes": () => {
        import(/* webpackChunkName: "requestrmaChunk" */ "@awc/App/WidgetExtensions/RequestRma/RequestRmaNotesExtensions");
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaNotes"
        );
	},
	"RequestRma/RequestRmaProductList": () => {
        import(/* webpackChunkName: "requestrmaChunk" */ "@awc/App/WidgetExtensions/RequestRma/RequestRmaProductListExtensions");
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaProductList"
        );
	},
	"RequestRma/RequestRmaProductListButtons": () => {
        return import(
            /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Widgets/RequestRma/RequestRmaProductListButtons"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationAddresses": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationAddresses"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationHeader": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/RequisitionConfirmation/RequisitionConfirmationHeaderExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationHeader"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationPageContainer": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/RequisitionConfirmation/RequisitionConfirmationPageContainerExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationPageContainer"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationProductList": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/RequisitionConfirmation/RequisitionConfirmationProductListExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationProductList"
        );
	},
	"RequisitionConfirmation/RequisitionConfirmationTotal": () => {
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationTotal"
        );
	},
	"Requisitions/RequisitionsHeader": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/Requisitions/RequisitionsHeaderExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsHeader"
        );
	},
	"Requisitions/RequisitionsProductList": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/Requisitions/RequisitionsProductListExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsProductList"
        );
	},
	"Requisitions/RequisitionsProductListLine": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/Requisitions/RequisitionsProductListLineExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsProductListLine"
        );
	},
	"Requisitions/RequisitionsRequisitionLineRow": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/Requisitions/RequisitionsRequisitionLineRowExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsRequisitionLineRow"
        );
	},
	"Requisitions/RequisitionsRequisitionLinesTable": () => {
        import(/* webpackChunkName: "requisitionsChunk" */ "@awc/App/WidgetExtensions/Requisitions/RequisitionsRequisitionLinesTableExtensions");
        return import(
            /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Widgets/Requisitions/RequisitionsRequisitionLinesTable"
        );
	},
	"ResetPassword/ResetPassword": () => {
        import(/* webpackChunkName: "resetpasswordChunk" */ "@awc/App/WidgetExtensions/ResetPassword/ResetPasswordExtensions");
        return import(
            /* webpackChunkName: "resetpasswordChunk" */ "@insite/content-library/Widgets/ResetPassword/ResetPassword"
        );
	},
	"RfqConfirmation/RfqConfirmationDetails": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqConfirmation/RfqConfirmationDetailsExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationDetails"
        );
	},
	"RfqConfirmation/RfqConfirmationHeader": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqConfirmation/RfqConfirmationHeaderExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader"
        );
	},
	"RfqConfirmation/RfqConfirmationProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationProductList"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsHeader": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsHeader"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsInformation": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqJobQuotes/RfqJobQuoteDetailsInformationExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsInformation"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsPageContainer": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsPageContainer"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsProductCard": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqJobQuotes/RfqJobQuoteDetailsProductCardExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsProductCard"
        );
	},
	"RfqJobQuoteDetails/RfqJobQuoteDetailsProductList": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqJobQuotes/RfqJobQuoteDetailsProductListExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsProductList"
        );
	},
	"RfqJobQuotes/RfqJobQuotesPagination": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuotes/RfqJobQuotesPagination"
        );
	},
	"RfqJobQuotes/RfqJobQuotesTable": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqJobQuotes/RfqJobQuotesTableExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuotes/RfqJobQuotesTable"
        );
	},
	"RfqJobQuotes/RfqJobQuotesTypeSelector": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqJobQuotes/RfqJobQuotesTypeSelectorExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqJobQuotes/RfqJobQuotesTypeSelector"
        );
	},
	"RfqMyQuotes/RfqMyQuotesFilter": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqMyQuotes/RfqMyQuotesFilterExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter"
        );
	},
	"RfqMyQuotes/RfqMyQuotesHeader": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqMyQuotes/RfqMyQuotesHeaderExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesHeader"
        );
	},
	"RfqMyQuotes/RfqMyQuotesPagination": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesPagination"
        );
	},
	"RfqMyQuotes/RfqMyQuotesTable": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqMyQuotes/RfqMyQuotesTableExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesTable"
        );
	},
	"RfqMyQuotes/RfqMyQuotesTypeSelector": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqMyQuotes/RfqMyQuotesTypeSelectorExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesTypeSelector"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsCustomerProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsCustomerProductList"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsHeader": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsHeaderExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsInformation": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsInformationExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsMessages": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsMessagesExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsPageContainer": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsPageContainer"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProductList"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItemExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRowExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsQuotedPricing": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuotedPricing"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGridExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductListExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList"
        );
	},
	"RfqRequestQuote/RfqRequestQuoteHeader": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteHeader"
        );
	},
	"RfqRequestQuote/RfqRequestQuotePageContainer": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqRequestQuote/RfqRequestQuotePageContainerExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuotePageContainer"
        );
	},
	"RfqRequestQuote/RfqRequestQuoteProductList": () => {
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteProductList"
        );
	},
	"RfqRequestQuote/RfqRequestQuoteSpecifications": () => {
        import(/* webpackChunkName: "rfqsChunk" */ "@awc/App/WidgetExtensions/RfqRequestQuote/RfqRequestQuoteSpecificationsExtensions");
        return import(
            /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteSpecifications"
        );
	},
	"RobotsTxt/RobotsTxtContent": () => {
        return import(
            /* webpackChunkName: "robotstxtChunk" */ "@insite/content-library/Widgets/RobotsTxt/RobotsTxtContent"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsActionButtons": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/SavedOrderDetails/SavedOrderDetailsActionButtonsExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsAddressModal": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/SavedOrderDetails/SavedOrderDetailsAddressModalExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsAddressModal"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsCartLine": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/SavedOrderDetails/SavedOrderDetailsCartLineExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsHeader": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/SavedOrderDetails/SavedOrderDetailsHeaderExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsHeader"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsOrderInformation": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/SavedOrderDetails/SavedOrderDetailsOrderInformationExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsProductList": () => {
        import(/* webpackChunkName: "orderdetailsChunk" */ "@awc/App/WidgetExtensions/SavedOrderDetails/SavedOrderDetailsProductListExtensions");
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList"
        );
	},
	"SavedOrderDetails/SavedOrderDetailsTotal": () => {
        return import(
            /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsTotal"
        );
	},
	"SavedOrderList/SavedOrderListFilter": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/SavedOrderList/SavedOrderListFilterExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter"
        );
	},
	"SavedOrderList/SavedOrderListHeader": () => {
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListHeader"
        );
	},
	"SavedOrderList/SavedOrderListPagination": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/SavedOrderList/SavedOrderListPaginationExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListPagination"
        );
	},
	"SavedOrderList/SavedOrderListTable": () => {
        import(/* webpackChunkName: "ordersChunk" */ "@awc/App/WidgetExtensions/SavedOrderList/SavedOrderListTableExtensions");
        return import(
            /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable"
        );
	},
	"SavedPayments/PaymentUtilities": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/PaymentUtilities"
        );
	},
	"SavedPayments/PaymetricDetailsEntry": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/PaymetricDetailsEntry"
        );
	},
	"SavedPayments/SavedPaymentsAddCardButton": () => {
        import(/* webpackChunkName: "savedpaymentsChunk" */ "@awc/App/WidgetExtensions/SavedPayments/SavedPaymentsAddCardButtonExtensions");
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton"
        );
	},
	"SavedPayments/SavedPaymentsCardList": () => {
        import(/* webpackChunkName: "savedpaymentsChunk" */ "@awc/App/WidgetExtensions/SavedPayments/SavedPaymentsCardListExtensions");
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList"
        );
	},
	"SavedPayments/SavedPaymentsDefaultCard": () => {
        import(/* webpackChunkName: "savedpaymentsChunk" */ "@awc/App/WidgetExtensions/SavedPayments/SavedPaymentsDefaultCardExtensions");
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard"
        );
	},
	"SavedPayments/SavedPaymentsEditCardModal": () => {
        import(/* webpackChunkName: "savedpaymentsChunk" */ "@awc/App/WidgetExtensions/SavedPayments/SavedPaymentsEditCardModalExtensions");
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal"
        );
	},
	"SavedPayments/SavedPaymentsView": () => {
        return import(
            /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView"
        );
	},
	"ServiceWorkerJs/ServiceWorkerJsContent": () => {
        return import(
            /* webpackChunkName: "serviceworkerjsChunk" */ "@insite/content-library/Widgets/ServiceWorkerJs/ServiceWorkerJsContent"
        );
	},
	"StaticList/StaticListHeader": () => {
        import(/* webpackChunkName: "staticlistChunk" */ "@awc/App/WidgetExtensions/StaticList/StaticListHeaderExtensions");
        return import(
            /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Widgets/StaticList/StaticListHeader"
        );
	},
	"StaticList/StaticListProductList": () => {
        import(/* webpackChunkName: "staticlistChunk" */ "@awc/App/WidgetExtensions/StaticList/StaticListProductListExtensions");
        return import(
            /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Widgets/StaticList/StaticListProductList"
        );
	},
	"StaticList/StaticListProductListLine": () => {
        import(/* webpackChunkName: "staticlistChunk" */ "@awc/App/WidgetExtensions/StaticList/StaticListProductListLineExtensions");
        return import(
            /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Widgets/StaticList/StaticListProductListLine"
        );
	},
	"StorePickupOverlay/StorePickup": () => {
        return import(
            /* webpackChunkName: "storepickupoverlayChunk" */ "@insite/content-library/Widgets/StorePickupOverlay/StorePickup"
        );
	},
	"UserList/CreateUserModal": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserList/CreateUserModalExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserList/CreateUserModal"
        );
	},
	"UserList/UserListHeader": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserList/UserListHeaderExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserList/UserListHeader"
        );
	},
	"UserList/UserListUsersTable": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserList/UserListUsersTableExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserList/UserListUsersTable"
        );
	},
	"UserSetup/AssignShipToAddressModal": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserSetup/AssignShipToAddressModalExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/AssignShipToAddressModal"
        );
	},
	"UserSetup/UserSetupHeader": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserSetup/UserSetupHeaderExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupHeader"
        );
	},
	"UserSetup/UserSetupSettings": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserSetup/UserSetupSettingsExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupSettings"
        );
	},
	"UserSetup/UserSetupStatus": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserSetup/UserSetupStatusExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupStatus"
        );
	},
	"UserSetup/UserSetupUserInformation": () => {
        import(/* webpackChunkName: "usersChunk" */ "@awc/App/WidgetExtensions/UserSetup/UserSetupUserInformationExtensions");
        return import(
            /* webpackChunkName: "usersChunk" */ "@insite/content-library/Widgets/UserSetup/UserSetupUserInformation"
        );
	},
	"VmiBinDetails/SearchUserField": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/SearchUserField"
        );
	},
	"VmiBinDetails/VmiBinDetailsButtons": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsButtons"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsActions"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsFilter"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsPagination"
        );
	},
	"VmiBinDetails/VmiBinDetailsCountsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsCountsTable"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersActions"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersFilter"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersPagination"
        );
	},
	"VmiBinDetails/VmiBinDetailsOrdersTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsOrdersTable"
        );
	},
	"VmiBinDetails/VmiBinDetailsProductInfo": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsProductInfo"
        );
	},
	"VmiBinDetails/VmiBinDetailsTabbedTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsTabbedTable"
        );
	},
	"VmiBinDetails/VmiBinDetailsTitle": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBinDetails/VmiBinDetailsTitle"
        );
	},
	"VmiBins/VmiBinsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsActions"
        );
	},
	"VmiBins/VmiBinsFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsFilter"
        );
	},
	"VmiBins/VmiBinsHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsHeader"
        );
	},
	"VmiBins/VmiBinsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsPagination"
        );
	},
	"VmiBins/VmiBinsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiBins/VmiBinsTable"
        );
	},
	"VmiDashboard/VmiDashboardBelowMinimum": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardBelowMinimum"
        );
	},
	"VmiDashboard/VmiDashboardFastMoving": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardFastMoving"
        );
	},
	"VmiDashboard/VmiDashboardHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardHeader"
        );
	},
	"VmiDashboard/VmiDashboardRecentNotes": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardRecentNotes"
        );
	},
	"VmiDashboard/VmiDashboardSlowMoving": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiDashboard/VmiDashboardSlowMoving"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsButtons": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsButtons"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsCustomerInfo": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsCustomerInfo"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsTabbedTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsTabbedTable"
        );
	},
	"VmiLocationDetails/VmiLocationDetailsTitle": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocationDetails/VmiLocationDetailsTitle"
        );
	},
	"VmiLocations/AddVmiLocationModal": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/AddVmiLocationModal"
        );
	},
	"VmiLocations/VmiLocationsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsActions"
        );
	},
	"VmiLocations/VmiLocationsHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsHeader"
        );
	},
	"VmiLocations/VmiLocationsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsPagination"
        );
	},
	"VmiLocations/VmiLocationsSearchBox": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsSearchBox"
        );
	},
	"VmiLocations/VmiLocationsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiLocations/VmiLocationsTable"
        );
	},
	"VmiReporting/SearchTextField": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/SearchTextField"
        );
	},
	"VmiReporting/VmiBinsActions": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsActions"
        );
	},
	"VmiReporting/VmiBinsFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsFilter"
        );
	},
	"VmiReporting/VmiBinsMetricFilter": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsMetricFilter"
        );
	},
	"VmiReporting/VmiBinsPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsPagination"
        );
	},
	"VmiReporting/VmiBinsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiBinsTable"
        );
	},
	"VmiReporting/VmiReportingHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiReporting/VmiReportingHeader"
        );
	},
	"VmiUsers/AddVmiUserModal": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/AddVmiUserModal"
        );
	},
	"VmiUsers/VmiLocationsTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiLocationsTable"
        );
	},
	"VmiUsers/VmiUsersHeader": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiUsersHeader"
        );
	},
	"VmiUsers/VmiUsersPagination": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiUsersPagination"
        );
	},
	"VmiUsers/VmiUsersTable": () => {
        return import(
            /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Widgets/VmiUsers/VmiUsersTable"
        );
	},
	"AlliedUnirversityLinks/AlliedUnirversityLinks": () => {
        import(/* webpackChunkName: "awcalliedunirversitylinksChunk" */ "@awc/App/WidgetExtensions/AlliedUnirversityLinks/AlliedUnirversityLinksExtensions");
        return import(
            /* webpackChunkName: "awcalliedunirversitylinksChunk" */ "@awc/App/Widgets/AlliedUnirversityLinks/AlliedUnirversityLinks"
        );
	},
	"AlliedUniversityArticleView/AlliedUniversityArticleView": () => {
        import(/* webpackChunkName: "awcallieduniversityarticleviewChunk" */ "@awc/App/WidgetExtensions/AlliedUniversityArticleView/AlliedUniversityArticleViewExtensions");
        return import(
            /* webpackChunkName: "awcallieduniversityarticleviewChunk" */ "@awc/App/Widgets/AlliedUniversityArticleView/AlliedUniversityArticleView"
        );
	},
	"AlliedUniversityCategoryView/AlliedUniversityCategoryView": () => {
        import(/* webpackChunkName: "awccategoriesChunk" */ "@awc/App/WidgetExtensions/AlliedUniversityCategoryView/AlliedUniversityCategoryViewExtensions");
        return import(
            /* webpackChunkName: "awccategoriesChunk" */ "@awc/App/Widgets/AlliedUniversityCategoryView/AlliedUniversityCategoryView"
        );
	},
	"AlliedUniversitySideNavigation/AlliedUniversityNavigationContainer": () => {
        import(/* webpackChunkName: "awcallieduniversitysidenavigationChunk" */ "@awc/App/WidgetExtensions/AlliedUniversitySideNavigation/AlliedUniversityNavigationContainerExtensions");
        return import(
            /* webpackChunkName: "awcallieduniversitysidenavigationChunk" */ "@awc/App/Widgets/AlliedUniversitySideNavigation/AlliedUniversityNavigationContainer"
        );
	},
	"AlliedUniversitySideNavigation/AlliedUniversitySideNavigationList": () => {
        import(/* webpackChunkName: "awcallieduniversitysidenavigationChunk" */ "@awc/App/WidgetExtensions/AlliedUniversitySideNavigation/AlliedUniversitySideNavigationListExtensions");
        return import(
            /* webpackChunkName: "awcallieduniversitysidenavigationChunk" */ "@awc/App/Widgets/AlliedUniversitySideNavigation/AlliedUniversitySideNavigationList"
        );
	},
	"AuthenticatedZone/AuthenticatedZone": () => {
        import(/* webpackChunkName: "awcauthenticatedzoneChunk" */ "@awc/App/WidgetExtensions/AuthenticatedZone/AuthenticatedZoneExtensions");
        return import(
            /* webpackChunkName: "awcauthenticatedzoneChunk" */ "@awc/App/Widgets/AuthenticatedZone/AuthenticatedZone"
        );
	},
	"BargainBin/BargainBin": () => {
        import(/* webpackChunkName: "awcbargainbinChunk" */ "@awc/App/WidgetExtensions/BargainBin/BargainBinExtensions");
        return import(
            /* webpackChunkName: "awcbargainbinChunk" */ "@awc/App/Widgets/BargainBin/BargainBin"
        );
	},
	"CategoryProductListContainer/CategoryProductListContainer": () => {
        return import(
            /* webpackChunkName: "awcproductsChunk" */ "@awc/App/Widgets/CategoryProductListContainer/CategoryProductListContainer"
        );
	},
	"Container/Container": () => {
        import(/* webpackChunkName: "awccontainerChunk" */ "@awc/App/WidgetExtensions/Container/ContainerExtensions");
        return import(
            /* webpackChunkName: "awccontainerChunk" */ "@awc/App/Widgets/Container/Container"
        );
	},
	"CustomForms/CartRfqForm": () => {
        import(/* webpackChunkName: "awccustomformsChunk" */ "@awc/App/WidgetExtensions/CustomForms/CartRfqFormExtensions");
        return import(
            /* webpackChunkName: "awccustomformsChunk" */ "@awc/App/Widgets/CustomForms/CartRfqForm"
        );
	},
	"CustomForms/ContactUsForm": () => {
        import(/* webpackChunkName: "awccustomformsChunk" */ "@awc/App/WidgetExtensions/CustomForms/ContactUsFormExtensions");
        return import(
            /* webpackChunkName: "awccustomformsChunk" */ "@awc/App/Widgets/CustomForms/ContactUsForm"
        );
	},
	"CustomForms/MainRfqForm": () => {
        import(/* webpackChunkName: "awccustomformsChunk" */ "@awc/App/WidgetExtensions/CustomForms/MainRfqFormExtensions");
        return import(
            /* webpackChunkName: "awccustomformsChunk" */ "@awc/App/Widgets/CustomForms/MainRfqForm"
        );
	},
	"CustomForms/QuickRfqFrom": () => {
        import(/* webpackChunkName: "awccustomformsChunk" */ "@awc/App/WidgetExtensions/CustomForms/QuickRfqFromExtensions");
        return import(
            /* webpackChunkName: "awccustomformsChunk" */ "@awc/App/Widgets/CustomForms/QuickRfqFrom"
        );
	},
	"DesignSystem/DesignSystem.helpers": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/DesignSystem.helpers"
        );
	},
	"DesignSystem/DesignSystem": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/DesignSystem"
        );
	},
	"DesignSystem/Components/AccordionsTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/AccordionsTab"
        );
	},
	"DesignSystem/Components/BreadcrumbsTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/BreadcrumbsTab"
        );
	},
	"DesignSystem/Components/ButtonsTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/ButtonsTab"
        );
	},
	"DesignSystem/Components/ColorsTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/ColorsTab"
        );
	},
	"DesignSystem/Components/CommonTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/CommonTab"
        );
	},
	"DesignSystem/Components/FormTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/FormTab"
        );
	},
	"DesignSystem/Components/IconsTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/IconsTab"
        );
	},
	"DesignSystem/Components/ModalTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/ModalTab"
        );
	},
	"DesignSystem/Components/NotifyTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/NotifyTab"
        );
	},
	"DesignSystem/Components/PaginationTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/PaginationTab"
        );
	},
	"DesignSystem/Components/TableTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/TableTab"
        );
	},
	"DesignSystem/Components/TabsTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/TabsTab"
        );
	},
	"DesignSystem/Components/ToastTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/ToastTab"
        );
	},
	"DesignSystem/Components/TooltipTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/TooltipTab"
        );
	},
	"DesignSystem/Components/TypographyTab": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/Components/TypographyTab"
        );
	},
	"DesignSystem/DummyData/DummyData": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/DummyData/DummyData"
        );
	},
	"DesignSystem/DummyData/DummyPaginationTable": () => {
        return import(
            /* webpackChunkName: "awcdesignsystemChunk" */ "@awc/App/Widgets/DesignSystem/DummyData/DummyPaginationTable"
        );
	},
	"EmailTester/EmailTester": () => {
        return import(
            /* webpackChunkName: "awcemailtesterChunk" */ "@awc/App/Widgets/EmailTester/EmailTester"
        );
	},
	"FeaturedCategories/FeaturedCategories": () => {
        import(/* webpackChunkName: "awccategoriesChunk" */ "@awc/App/WidgetExtensions/FeaturedCategories/FeaturedCategoriesExtensions");
        return import(
            /* webpackChunkName: "awccategoriesChunk" */ "@awc/App/Widgets/FeaturedCategories/FeaturedCategories"
        );
	},
	"GoogleAnalyticsConnector/Utilities/DataLayer": () => {
        return import(
            /* webpackChunkName: "awcgoogleanalyticsconnectorChunk" */ "@awc/App/Widgets/GoogleAnalyticsConnector/Utilities/DataLayer"
        );
	},
	"GoogleAnalyticsConnector/Widgets/GoogleAnalyticsConnector": () => {
        return import(
            /* webpackChunkName: "awcgoogleanalyticsconnectorChunk" */ "@awc/App/Widgets/GoogleAnalyticsConnector/Widgets/GoogleAnalyticsConnector"
        );
	},
	"HelpWidget/HelpWidget": () => {
        import(/* webpackChunkName: "awchelpwidgetChunk" */ "@awc/App/WidgetExtensions/HelpWidget/HelpWidgetExtensions");
        return import(
            /* webpackChunkName: "awchelpwidgetChunk" */ "@awc/App/Widgets/HelpWidget/HelpWidget"
        );
	},
	"InfoCard/InfoCard": () => {
        import(/* webpackChunkName: "awcinfocardChunk" */ "@awc/App/WidgetExtensions/InfoCard/InfoCardExtensions");
        return import(
            /* webpackChunkName: "awcinfocardChunk" */ "@awc/App/Widgets/InfoCard/InfoCard"
        );
	},
	"Layout/MyAccountDetailsPagesLayout": () => {
        import(/* webpackChunkName: "awclayoutChunk" */ "@awc/App/WidgetExtensions/Layout/MyAccountDetailsPagesLayoutExtensions");
        return import(
            /* webpackChunkName: "awclayoutChunk" */ "@awc/App/Widgets/Layout/MyAccountDetailsPagesLayout"
        );
	},
	"Layout/MyAccountListPagesLayout": () => {
        import(/* webpackChunkName: "awclayoutChunk" */ "@awc/App/WidgetExtensions/Layout/MyAccountListPagesLayoutExtensions");
        return import(
            /* webpackChunkName: "awclayoutChunk" */ "@awc/App/Widgets/Layout/MyAccountListPagesLayout"
        );
	},
	"Layout/SignInPageLayout": () => {
        import(/* webpackChunkName: "awclayoutChunk" */ "@awc/App/WidgetExtensions/Layout/SignInPageLayoutExtensions");
        return import(
            /* webpackChunkName: "awclayoutChunk" */ "@awc/App/Widgets/Layout/SignInPageLayout"
        );
	},
	"LeadTimeCalculator/LeadTimeCalculator": () => {
        import(/* webpackChunkName: "awcleadtimecalculatorChunk" */ "@awc/App/WidgetExtensions/LeadTimeCalculator/LeadTimeCalculatorExtensions");
        return import(
            /* webpackChunkName: "awcleadtimecalculatorChunk" */ "@awc/App/Widgets/LeadTimeCalculator/LeadTimeCalculator"
        );
	},
	"MyAccount/MyAccountNavigationList": () => {
        import(/* webpackChunkName: "awcmyaccountChunk" */ "@awc/App/WidgetExtensions/MyAccount/MyAccountNavigationListExtensions");
        return import(
            /* webpackChunkName: "awcmyaccountChunk" */ "@awc/App/Widgets/MyAccount/MyAccountNavigationList"
        );
	},
	"MyLists/MyListsFilterLayout": () => {
        import(/* webpackChunkName: "awcmylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsFilterLayoutExtensions");
        return import(
            /* webpackChunkName: "awcmylistsChunk" */ "@awc/App/Widgets/MyLists/MyListsFilterLayout"
        );
	},
	"MyLists/MyListsFilterTag": () => {
        import(/* webpackChunkName: "awcmylistsChunk" */ "@awc/App/WidgetExtensions/MyLists/MyListsFilterTagExtensions");
        return import(
            /* webpackChunkName: "awcmylistsChunk" */ "@awc/App/Widgets/MyLists/MyListsFilterTag"
        );
	},
	"MyLists/MyListsTitleCount": () => {
        return import(
            /* webpackChunkName: "awcmylistsChunk" */ "@awc/App/Widgets/MyLists/MyListsTitleCount"
        );
	},
	"OrderApprovalList/OrderApprovalListTitleCount": () => {
        return import(
            /* webpackChunkName: "awcorderapprovalChunk" */ "@awc/App/Widgets/OrderApprovalList/OrderApprovalListTitleCount"
        );
	},
	"OrderConfirmation/OrderConfirmationPageTitle": () => {
        import(/* webpackChunkName: "awcorderconfirmationChunk" */ "@awc/App/WidgetExtensions/OrderConfirmation/OrderConfirmationPageTitleExtensions");
        return import(
            /* webpackChunkName: "awcorderconfirmationChunk" */ "@awc/App/Widgets/OrderConfirmation/OrderConfirmationPageTitle"
        );
	},
	"OrderDetails/OrderDetailsInformationLayout": () => {
        import(/* webpackChunkName: "awcorderdetailsChunk" */ "@awc/App/WidgetExtensions/OrderDetails/OrderDetailsInformationLayoutExtensions");
        return import(
            /* webpackChunkName: "awcorderdetailsChunk" */ "@awc/App/Widgets/OrderDetails/OrderDetailsInformationLayout"
        );
	},
	"OrderHistory/OrderHistoryFiltersLayout": () => {
        import(/* webpackChunkName: "awcordersChunk" */ "@awc/App/WidgetExtensions/OrderHistory/OrderHistoryFiltersLayoutExtensions");
        return import(
            /* webpackChunkName: "awcordersChunk" */ "@awc/App/Widgets/OrderHistory/OrderHistoryFiltersLayout"
        );
	},
	"OrderHistory/OrderHistoryTitleCount": () => {
        return import(
            /* webpackChunkName: "awcordersChunk" */ "@awc/App/Widgets/OrderHistory/OrderHistoryTitleCount"
        );
	},
	"OrderUpload/OrderUploadInstructions": () => {
        import(/* webpackChunkName: "awcorderuploadChunk" */ "@awc/App/WidgetExtensions/OrderUpload/OrderUploadInstructionsExtensions");
        return import(
            /* webpackChunkName: "awcorderuploadChunk" */ "@awc/App/Widgets/OrderUpload/OrderUploadInstructions"
        );
	},
	"PrivacyChoices/PrivacyChoices": () => {
        import(/* webpackChunkName: "awcprivacychoicesChunk" */ "@awc/App/WidgetExtensions/PrivacyChoices/PrivacyChoicesExtensions");
        return import(
            /* webpackChunkName: "awcprivacychoicesChunk" */ "@awc/App/Widgets/PrivacyChoices/PrivacyChoices"
        );
	},
	"ProductDetails/ProductDetailsActions": () => {
        import(/* webpackChunkName: "awcproductsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsActionsExtensions");
        return import(
            /* webpackChunkName: "awcproductsChunk" */ "@awc/App/Widgets/ProductDetails/ProductDetailsActions"
        );
	},
	"ProductDetails/ProductDetailsBargain": () => {
        import(/* webpackChunkName: "awcproductsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsBargainExtensions");
        return import(
            /* webpackChunkName: "awcproductsChunk" */ "@awc/App/Widgets/ProductDetails/ProductDetailsBargain"
        );
	},
	"ProductDetails/ProductDetailsCarousel": () => {
        return import(
            /* webpackChunkName: "awcproductsChunk" */ "@awc/App/Widgets/ProductDetails/ProductDetailsCarousel"
        );
	},
	"ProductDetails/ProductDetailsOverstockSale": () => {
        import(/* webpackChunkName: "awcproductsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsOverstockSaleExtensions");
        return import(
            /* webpackChunkName: "awcproductsChunk" */ "@awc/App/Widgets/ProductDetails/ProductDetailsOverstockSale"
        );
	},
	"ProductDetails/ProductDetailsVariantCustomView": () => {
        import(/* webpackChunkName: "awcproductsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductDetailsVariantCustomViewExtensions");
        return import(
            /* webpackChunkName: "awcproductsChunk" */ "@awc/App/Widgets/ProductDetails/ProductDetailsVariantCustomView"
        );
	},
	"ProductDetails/ProductLongDescription": () => {
        import(/* webpackChunkName: "awcproductsChunk" */ "@awc/App/WidgetExtensions/ProductDetails/ProductLongDescriptionExtensions");
        return import(
            /* webpackChunkName: "awcproductsChunk" */ "@awc/App/Widgets/ProductDetails/ProductLongDescription"
        );
	},
	"ReelCapacityCalculator/ReelCapacityCalculator": () => {
        import(/* webpackChunkName: "awcreelcapacitycalculatorChunk" */ "@awc/App/WidgetExtensions/ReelCapacityCalculator/ReelCapacityCalculatorExtensions");
        return import(
            /* webpackChunkName: "awcreelcapacitycalculatorChunk" */ "@awc/App/Widgets/ReelCapacityCalculator/ReelCapacityCalculator"
        );
	},
	"RfqMyQuotes/RfqMyQuotesTitleCount": () => {
        return import(
            /* webpackChunkName: "awcrfqsChunk" */ "@awc/App/Widgets/RfqMyQuotes/RfqMyQuotesTitleCount"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsActions": () => {
        return import(
            /* webpackChunkName: "awcrfqsChunk" */ "@awc/App/Widgets/RfqQuoteDetails/RfqQuoteDetailsActions"
        );
	},
	"RfqQuoteDetails/RfqQuoteDetailsTotal": () => {
        import(/* webpackChunkName: "awcrfqsChunk" */ "@awc/App/WidgetExtensions/RfqQuoteDetails/RfqQuoteDetailsTotalExtensions");
        return import(
            /* webpackChunkName: "awcrfqsChunk" */ "@awc/App/Widgets/RfqQuoteDetails/RfqQuoteDetailsTotal"
        );
	},
	"SalesRepInformation/SalesRepInformation": () => {
        import(/* webpackChunkName: "awcsalesrepinformationChunk" */ "@awc/App/WidgetExtensions/SalesRepInformation/SalesRepInformationExtensions");
        return import(
            /* webpackChunkName: "awcsalesrepinformationChunk" */ "@awc/App/Widgets/SalesRepInformation/SalesRepInformation"
        );
	},
	"SavedOrders/SavedOrdersTitleCount": () => {
        return import(
            /* webpackChunkName: "awcordersChunk" */ "@awc/App/Widgets/SavedOrders/SavedOrdersTitleCount"
        );
	},
	"SavedPayments/SavedPaymentsTitleCount": () => {
        return import(
            /* webpackChunkName: "awcsavedpaymentsChunk" */ "@awc/App/Widgets/SavedPayments/SavedPaymentsTitleCount"
        );
	},
	"SearchEngineOptimization/SearchEngineOptimization": () => {
        return import(
            /* webpackChunkName: "awcsearchengineoptimizationChunk" */ "@awc/App/Widgets/SearchEngineOptimization/SearchEngineOptimization"
        );
	},
	"ToggleFilters/ToggleFilters": () => {
        return import(
            /* webpackChunkName: "awctogglefiltersChunk" */ "@awc/App/Widgets/ToggleFilters/ToggleFilters"
        );
	},
	"ToggleFilters/ToggleFiltersComponent": () => {
        import(/* webpackChunkName: "awctogglefiltersChunk" */ "@awc/App/WidgetExtensions/ToggleFilters/ToggleFiltersComponentExtensions");
        return import(
            /* webpackChunkName: "awctogglefiltersChunk" */ "@awc/App/Widgets/ToggleFilters/ToggleFiltersComponent"
        );
	},
	"UtmParametersSessionTracker/UtmParametersSessionTracker": () => {
        return import(
            /* webpackChunkName: "awcutmparameterssessiontrackerChunk" */ "@awc/App/Widgets/UtmParametersSessionTracker/UtmParametersSessionTracker"
        );
	},
	"ValueAddedServices/ValueAddedServices": () => {
        import(/* webpackChunkName: "awcvalueaddedservicesChunk" */ "@awc/App/WidgetExtensions/ValueAddedServices/ValueAddedServicesExtensions");
        return import(
            /* webpackChunkName: "awcvalueaddedservicesChunk" */ "@awc/App/Widgets/ValueAddedServices/ValueAddedServices"
        );
	},
	"ValueAddedServices/ValueAddedServicesSideBar": () => {
        import(/* webpackChunkName: "awcvalueaddedservicesChunk" */ "@awc/App/WidgetExtensions/ValueAddedServices/ValueAddedServicesSideBarExtensions");
        return import(
            /* webpackChunkName: "awcvalueaddedservicesChunk" */ "@awc/App/Widgets/ValueAddedServices/ValueAddedServicesSideBar"
        );
	},
	"Video/Video": () => {
        return import(
            /* webpackChunkName: "awcvideoChunk" */ "@awc/App/Widgets/Video/Video"
        );
	},
	"VoltageDropCalculator/VoltageDropCaculator": () => {
        import(/* webpackChunkName: "awcvoltagedropcalculatorChunk" */ "@awc/App/WidgetExtensions/VoltageDropCalculator/VoltageDropCaculatorExtensions");
        return import(
            /* webpackChunkName: "awcvoltagedropcalculatorChunk" */ "@awc/App/Widgets/VoltageDropCalculator/VoltageDropCaculator"
        );
	},
	"XTabs/XTabs": () => {
        return import(
            /* webpackChunkName: "awcxtabsChunk" */ "@awc/App/Widgets/XTabs/XTabs"
        );
	},
    AccountSettingsPage: () => {
            return import(
                /* webpackChunkName: "accountsettingsChunk" */ "@insite/content-library/Pages/AccountSettingsPage"
            );
        },
    AddressBookOverlay: () => {
            return import(
                /* webpackChunkName: "addressbookoverlay.tsxChunk" */ "@insite/content-library/Pages/AddressBookOverlay"
            );
        },
    AddressesPage: () => {
            return import(
                /* webpackChunkName: "addressesChunk" */ "@insite/content-library/Pages/AddressesPage"
            );
        },
    BrandDetailsPage: () => {
            return import(
                /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Pages/BrandDetailsPage"
            );
        },
    BrandsPage: () => {
            return import(
                /* webpackChunkName: "brandsChunk" */ "@insite/content-library/Pages/BrandsPage"
            );
        },
    BudgetManagementPage: () => {
            return import(
                /* webpackChunkName: "budgetsChunk" */ "@insite/content-library/Pages/BudgetManagementPage"
            );
        },
    CartPage: () => {
            return import(
                /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Pages/CartPage"
            );
        },
    CartReminderUnsubscribePage: () => {
            return import(
                /* webpackChunkName: "cartsChunk" */ "@insite/content-library/Pages/CartReminderUnsubscribePage"
            );
        },
    CategoryDetailsPage: () => {
            return import(
                /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Pages/CategoryDetailsPage"
            );
        },
    CategoryListPage: () => {
            return import(
                /* webpackChunkName: "categoriesChunk" */ "@insite/content-library/Pages/CategoryListPage"
            );
        },
    ChangeCustomerPage: () => {
            return import(
                /* webpackChunkName: "changesChunk" */ "@insite/content-library/Pages/ChangeCustomerPage"
            );
        },
    ChangePasswordPage: () => {
            return import(
                /* webpackChunkName: "changesChunk" */ "@insite/content-library/Pages/ChangePasswordPage"
            );
        },
    CheckoutReviewAndSubmitPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/CheckoutReviewAndSubmitPage"
            );
        },
    CheckoutShippingPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/CheckoutShippingPage"
            );
        },
    CreateAccountPage: () => {
            return import(
                /* webpackChunkName: "createaccountChunk" */ "@insite/content-library/Pages/CreateAccountPage"
            );
        },
    DealerDetailsPage: () => {
            return import(
                /* webpackChunkName: "dealerdetailsChunk" */ "@insite/content-library/Pages/DealerDetailsPage"
            );
        },
    ExpiredAccountActivationLinkPage: () => {
            return import(
                /* webpackChunkName: "expiredaccountactivationlinkChunk" */ "@insite/content-library/Pages/ExpiredAccountActivationLinkPage"
            );
        },
    ExpiredResetPasswordLinkPage: () => {
            return import(
                /* webpackChunkName: "expiredresetpasswordlinkChunk" */ "@insite/content-library/Pages/ExpiredResetPasswordLinkPage"
            );
        },
    InvoiceDetailsPage: () => {
            return import(
                /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Pages/InvoiceDetailsPage"
            );
        },
    InvoiceHistoryPage: () => {
            return import(
                /* webpackChunkName: "invoicesChunk" */ "@insite/content-library/Pages/InvoiceHistoryPage"
            );
        },
    LlmsTxtPage: () => {
            return import(
                /* webpackChunkName: "llmstxtChunk" */ "@insite/content-library/Pages/LlmsTxtPage"
            );
        },
    LocationFinderPage: () => {
            return import(
                /* webpackChunkName: "locationfinderChunk" */ "@insite/content-library/Pages/LocationFinderPage"
            );
        },
    MaintenancePage: () => {
            return import(
                /* webpackChunkName: "maintenanceChunk" */ "@insite/content-library/Pages/MaintenancePage"
            );
        },
    ManifestJsonPage: () => {
            return import(
                /* webpackChunkName: "manifestjsonChunk" */ "@insite/content-library/Pages/ManifestJsonPage"
            );
        },
    MyAccountPage: () => {
            return import(
                /* webpackChunkName: "myaccountChunk" */ "@insite/content-library/Pages/MyAccountPage"
            );
        },
    MyListsDetailsPage: () => {
            return import(
                /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Pages/MyListsDetailsPage"
            );
        },
    MyListsPage: () => {
            return import(
                /* webpackChunkName: "mylistsChunk" */ "@insite/content-library/Pages/MyListsPage"
            );
        },
    NewsListPage: () => {
            return import(
                /* webpackChunkName: "newsChunk" */ "@insite/content-library/Pages/NewsListPage"
            );
        },
    NewsPage: () => {
            return import(
                /* webpackChunkName: "newsChunk" */ "@insite/content-library/Pages/NewsPage"
            );
        },
    NotFoundErrorPage: () => {
            return import(
                /* webpackChunkName: "notfounderrorChunk" */ "@insite/content-library/Pages/NotFoundErrorPage"
            );
        },
    OnePageCheckoutConfirmationPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/OnePageCheckoutConfirmationPage"
            );
        },
    OnePageCheckoutPage: () => {
            return import(
                /* webpackChunkName: "checkoutsChunk" */ "@insite/content-library/Pages/OnePageCheckoutPage"
            );
        },
    OrderApprovalDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Pages/OrderApprovalDetailsPage"
            );
        },
    OrderApprovalListPage: () => {
            return import(
                /* webpackChunkName: "orderapprovalChunk" */ "@insite/content-library/Pages/OrderApprovalListPage"
            );
        },
    OrderConfirmationPage: () => {
            return import(
                /* webpackChunkName: "orderconfirmationChunk" */ "@insite/content-library/Pages/OrderConfirmationPage"
            );
        },
    OrderDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Pages/OrderDetailsPage"
            );
        },
    OrderHistoryPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/OrderHistoryPage"
            );
        },
    OrderStatusPage: () => {
            return import(
                /* webpackChunkName: "orderstatusChunk" */ "@insite/content-library/Pages/OrderStatusPage"
            );
        },
    OrderUploadPage: () => {
            return import(
                /* webpackChunkName: "orderuploadChunk" */ "@insite/content-library/Pages/OrderUploadPage"
            );
        },
    Page: () => {
            return import(
                /* webpackChunkName: "pageChunk" */ "@insite/content-library/Pages/Page"
            );
        },
    ProductComparePage: () => {
            return import(
                /* webpackChunkName: "productsChunk" */ "@insite/content-library/Pages/ProductComparePage"
            );
        },
    ProductDetailsPage: () => {
            return import(
                /* webpackChunkName: "productsChunk" */ "@insite/content-library/Pages/ProductDetailsPage"
            );
        },
    ProductListPage: () => {
            return import(
                /* webpackChunkName: "productsChunk" */ "@insite/content-library/Pages/ProductListPage"
            );
        },
    QuickOrderPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/QuickOrderPage"
            );
        },
    RequestRmaPage: () => {
            return import(
                /* webpackChunkName: "requestrmaChunk" */ "@insite/content-library/Pages/RequestRmaPage"
            );
        },
    RequisitionConfirmationPage: () => {
            return import(
                /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Pages/RequisitionConfirmationPage"
            );
        },
    RequisitionsPage: () => {
            return import(
                /* webpackChunkName: "requisitionsChunk" */ "@insite/content-library/Pages/RequisitionsPage"
            );
        },
    ResetPasswordPage: () => {
            return import(
                /* webpackChunkName: "resetpasswordChunk" */ "@insite/content-library/Pages/ResetPasswordPage"
            );
        },
    RfqConfirmationPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqConfirmationPage"
            );
        },
    RfqJobQuoteDetailsPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqJobQuoteDetailsPage"
            );
        },
    RfqJobQuotesPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqJobQuotesPage"
            );
        },
    RfqMyQuotesPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqMyQuotesPage"
            );
        },
    RfqQuoteDetailsPage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqQuoteDetailsPage"
            );
        },
    RfqRequestQuotePage: () => {
            return import(
                /* webpackChunkName: "rfqsChunk" */ "@insite/content-library/Pages/RfqRequestQuotePage"
            );
        },
    RobotsTxtPage: () => {
            return import(
                /* webpackChunkName: "robotstxtChunk" */ "@insite/content-library/Pages/RobotsTxtPage"
            );
        },
    SavedOrderDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Pages/SavedOrderDetailsPage"
            );
        },
    SavedOrderListPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/SavedOrderListPage"
            );
        },
    SavedPaymentsPage: () => {
            return import(
                /* webpackChunkName: "savedpaymentsChunk" */ "@insite/content-library/Pages/SavedPaymentsPage"
            );
        },
    ServiceWorkerJsPage: () => {
            return import(
                /* webpackChunkName: "serviceworkerjsChunk" */ "@insite/content-library/Pages/ServiceWorkerJsPage"
            );
        },
    SignInOverlay: () => {
            return import(
                /* webpackChunkName: "signinoverlay.tsxChunk" */ "@insite/content-library/Pages/SignInOverlay"
            );
        },
    StaticListPage: () => {
            return import(
                /* webpackChunkName: "staticlistChunk" */ "@insite/content-library/Pages/StaticListPage"
            );
        },
    StorePickupOverlay: () => {
            return import(
                /* webpackChunkName: "storepickupoverlay.tsxChunk" */ "@insite/content-library/Pages/StorePickupOverlay"
            );
        },
    UnhandledErrorPage: () => {
            return import(
                /* webpackChunkName: "unhandlederrorChunk" */ "@insite/content-library/Pages/UnhandledErrorPage"
            );
        },
    UserListPage: () => {
            return import(
                /* webpackChunkName: "usersChunk" */ "@insite/content-library/Pages/UserListPage"
            );
        },
    UserSetupPage: () => {
            return import(
                /* webpackChunkName: "usersChunk" */ "@insite/content-library/Pages/UserSetupPage"
            );
        },
    VmiBinDetailsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiBinDetailsPage"
            );
        },
    VmiBinsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiBinsPage"
            );
        },
    VmiDashboardPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiDashboardPage"
            );
        },
    VmiLocationDetailsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiLocationDetailsPage"
            );
        },
    VmiLocationsPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiLocationsPage"
            );
        },
    VmiOrderDetailsPage: () => {
            return import(
                /* webpackChunkName: "orderdetailsChunk" */ "@insite/content-library/Pages/VmiOrderDetailsPage"
            );
        },
    VmiOrderHistoryPage: () => {
            return import(
                /* webpackChunkName: "ordersChunk" */ "@insite/content-library/Pages/VmiOrderHistoryPage"
            );
        },
    VmiReportingPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiReportingPage"
            );
        },
    VmiUsersPage: () => {
            return import(
                /* webpackChunkName: "vmisChunk" */ "@insite/content-library/Pages/VmiUsersPage"
            );
        },
        
    }
	export default importChunkObj
